// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3duGH","content":"ManualTimeModal_content__2CSmo"};